import Swal from "sweetalert2";
import { type Component } from "vue";
import { useLoadingStore } from "../stores/loading.store";

export async function loadView(viewComponent: Promise<Component>) {
    return viewComponent.catch((e) => {
        useLoadingStore().toggle(false);
        console.error((e as Error).cause);

        Swal.fire({
            icon: "warning",
            title: "GAGAL MEMUAT HALAMAN",
            text: "Hal ini bisa terjadi karena adanya update pada aplikasi atau masalah pada jaringan internet.",
            confirmButtonText: "Muat Ulang Aplikasi",
        }).then(() => window.location.reload());
    });
}
